import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';

import { useDictionaries } from 'entities/creditForm';

export const EmploymentType: FC<IFieldFactoryProps> = (props) => {
  const { employmentTypes } = useDictionaries(['employmentTypes']);
  const { type, ...other } = props;

  return (
    <ControlledCustomSelect
      {...other}
      name={type}
      options={employmentTypes}
      withCrossIcon={false}
    />
  );
};
